var _ = require("../../uam/module.js")(module.exports, {
  namespace: "egt.baa",
  title: "EGT BAA page",
  description: "Renders the EGT Business Associate Agreement (HIPAA) verbatim from markdown with a skin + section TOC.",
  supportServer: true
});
var fm = require("../../uam/filemanager.js");
var mdr = require("../helpers/egt.markdown.js");
var S = require("../helpers/egt.sections.js");

/* The BAA renders EXACTLY like the Codex (egt.codex.js): the legal text is served
 * VERBATIM from app/content/legal/baa.md, skinned only — never rewritten. Same
 * doc shell: fixed full-viewport background, fixed TOC rail that follows the
 * reader (scrollspy via egt.legal.js), site-wide reading-progress hairline. No
 * "request" copy, no overview.
 *
 * The version and effective date are NOT restated here. They are the document's
 * own first two lines and render immediately below this masthead; a second copy
 * in code said "Version 3" next to a body that said "Version 3", and would have
 * gone on saying it after the markdown moved to Version 4. The Codex masthead
 * carries no version for the same reason. BAA Section 11 asks that the current
 * version be published "with a version identifier" — it is, in the document,
 * which is the one place it cannot drift from the text it identifies. */
exports.render = async function render() {
  var p = fm.resolve("@!/app/content/legal/baa.md");
  var raw = fm.exists(p) ? fm.load(p) : "# Business Associate Agreement\n\nThe document is being prepared.";
  var doc = mdr.render(raw);

  // TOC links carry data-egt-spy-link + a target id for the scrollspy client
  // (egt.legal.js). The same nav is reused inside a mobile <details> disclosure
  // (CSS swaps which one shows). Parts are primary entries; subsections indented.
  function tocNav() {
    return { n: "nav", c: "egt-doc__toc-nav", "aria-label": "Business Associate Agreement contents",
      i: doc.toc.map(function (t) {
        return { n: "a", href: "#" + t.id, "data-egt-spy-link": t.id,
          c: "egt-doc__toc-link" + (t.sub ? " is-sub" : ""), i: t.text };
      }) };
  }

  var toc = {
    n: "aside", c: "egt-doc__toc egt-doc__toc--rail",
    i: [
      { n: "p", c: "egt-doc__toc-h", i: "Contents" },
      tocNav()
    ]
  };

  // Mobile / tablet: native <details> disclosure that auto-closes on jump (JS).
  var tocMobile = {
    n: "details", c: "egt-doc__toc-disc", id: "egt-baa-toc-disc",
    i: [
      { n: "summary", c: "egt-doc__toc-disc-sum",
        i: [ { n: "span", i: "Contents" }, { n: "span", c: "egt-doc__toc-disc-x", "aria-hidden": "true", i: "+" } ] },
      tocNav()
    ]
  };

  var masthead = {
    n: "div", c: "egt-doc__head egt-reveal",
    i: [
      { n: "p", c: "egt__eyebrow", i: "Legal" },
      { n: "h1", c: "egt-doc__title", i: doc.title }
    ]
  };

  // FIXED full-viewport background — the default pages-background pattern
  // (a real <img>, object-fit:cover, position:fixed at 100vw×100vh behind the
  // content). NOT inside .egt-canvas, so it is decoupled from the very tall
  // document and never stretched, and leaves NO overflow:hidden ancestor over
  // the sticky TOC rail. Undimmed — contrast from the frosted cards only.
  var background = {
    n: "img", c: "egt-legal-doc__bg", src: "/imgs/egt-legal-canvas.jpg",
    alt: "", "aria-hidden": "true", decoding: "async", fetchpriority: "high"
  };

  var section = {
    n: "section", c: "egt-section egt-doc egt-legal-doc",
    i: [
      // reading-progress hairline is site-wide — S.page() renders it (egt.sections.js).
      { n: "a", href: "#egt-baa-body", c: "egt-doc__skip", i: "Skip to the document" },
      background,
      { n: "div", c: "egt__shell egt-doc__shell",
        i: [
          masthead,
          { n: "div", c: "egt-doc__layout egt-doc--glass",
            i: [
              { n: "div", c: "egt-doc__rail",
                i: [ tocMobile, toc ] },
              { n: "article", c: "egt-doc__body", id: "egt-baa-body",
                "data-egt-spy": "true", i: doc.nodes }
            ] }
        ] }
    ]
  };
  return S.page("/reserve", [ section,
    /* JSON-LD: WebPage + BreadcrumbList (SEO wave 2B-7) */
    S.pageSchema({ path: "/legal/baa", name: "EGT Business Associate Agreement (HIPAA)", crumbs: [ { name: "Business Associate Agreement" } ] }) ]);
};
